import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkTable from "../../components/atoms/TkTable";
import { Box } from "@mui/material";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkButton from "../../components/atoms/TkButton";
import { httpIAPI_FAC032 } from "./api/request";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { GlobalContext } from "../../context/globalContext";
import { infoHeadTitleList } from "./parts";
import { FacilityKind } from "../../assets/data/Constants";
import { BusinessContext } from "../../context/businessContext";
import { useNavigate } from "react-router";
import { labelids } from "../../assets/data/TkExplanationProperty";

/**
 * SCRC050114 従業状況の更新　施設一覧
 * @return SCRC050114 従業状況の更新　施設一覧
 */

const SCRC050114 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext<any>(BusinessContext);
  const userType = state?.authInfo?.userType;
  const [, setPramaData] = useState<any>();
  const [infoTableList, setInfoTableList] = useState<any>([]);

  // 初期化
  const handleInit = async () => {
    try {
      const res = (await httpIAPI_FAC032({
        contractorNo:
          userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo || ""
            : state?.authInfo?.contractorNo || "",
      })) as { [key: string]: any };

      setPramaData(res);
      if (res.resultCd === "I0000") {
        const infoBodyList = funInfoBodyList(res.facilityList);
        setInfoTableList(infoBodyList);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 次へ
  const handleSubmit = () => {
    switch (businessState?.common?.businessType) {
      case "JOB-04":
        navigate("/SCRC050113");
        return;
      case "JOB-03":
        navigate("/SCRC050110");
        return;
      case "JOB-16":
        navigate("/SCRC050125");
        return;
      default:
        return;
    }
  };

  /**
   * 施設一覧テーブルを作成する
   * @param res
   * @returns infoBodyList
   */
  function funInfoBodyList(res: any) {
    const infoBodyList = res?.map((item: any) => [
      {
        children: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
      },
      {
        children: FacilityKind[item.facilityKind as keyof typeof FacilityKind],
      },
      {
        children: item.updateDate,
        align: "center",
      },
      {
        children: (
          <TkButton
            onClick={() => handleUpdate(item.facilityNo, item.facilityName)}
          >
            更新
          </TkButton>
        ),
        align: "center",
      },
    ]);

    return infoBodyList ?? [];
  }

  //更新ボタン用イベント
  const handleUpdate = (facilityNo: any, facilityName: any) => {
    navigate("/SCRC060112", {
      state: {
        facilityNo: facilityNo,
        facilityName: facilityName,
      },
    });
  };

  return (
    <Box data-testid="SCRC050114PageForTest" className="SCRC050114">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050114_01}</TkInfoManual>
      {state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState?.common?.contractorNo +
            ":" +
            businessState?.common?.contractorName
          }
        />
      )}
      <TkTable bodyList={infoTableList} headList={infoHeadTitleList} />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050114_02}</TkInfoManual>
      <Box className="butt">
        <TkBackButton />
        <TkButton onClick={() => handleSubmit()}>次へ</TkButton>
      </Box>
    </Box>
  );
};

export default SCRC050114;
